import React from "react";

const ourProcess = [
  {
    icon: "flaticon-idea-1",
    title: "Ideation",
    heading: "Transform ideas into actionable plans",
    description:
      "Validate concepts, define scope, and prioritize features through collaborative brainstorming and market research.",
    id: 1,
  },
  {
    icon: "flaticon-blueprint",
    title: "Architecture",
    heading: "Build scalable, secure foundations",
    description:
      "Design system structure, select technologies, and ensure compliance for long-term performance and reliability.",
    id: 2,
  },
  {
    icon: "flaticon-coding-1",
    title: "Development",
    heading: "Code with precision and agility",
    description:
      "Implement features in iterative sprints using modern frameworks and best practices.",
    id: 3,
  },
  {
    imgSrc: require(`../../assets/images/process/testing.png`),
    title: "Testing",
    heading: "Ensure flawless performance",
    description:
      "Rigorous QA, automation, and user testing to eliminate bugs and optimize functionality.",
    id: 4,
  },
  {
    imgSrc: require(`../../assets/images/process/deployment.png`),
    title: "Deployment",
    heading: "Launch seamlessly, anytime",
    description:
      "Zero-downtime releases with CI/CD pipelines for smooth, error-free go-live.",
    id: 5,
  },
  {
    imgSrc: require(`../../assets/images/process/scale_optimize.png`),
    title: "Scale & Optimize",
    heading: "Grow smarter, not harder",
    description:
      "Monitor, refine, and expand systems to handle growth and evolving needs.",
    id: 6,
    className: "no-border mb-0",
  },
];

export default function WorkprocessSection() {
  return (
    <section className="work-progress-two">
      <div className="container-fluid clearfix px-70">
        <div className="work-progress-inner-two">
          <div
            className="grid-container justify-content-center"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
              alignItems: "stretch",
              rowGap: "62.5px",
            }}
          >
            {ourProcess.map(
              ({
                icon,
                imgSrc,
                title,
                description,
                id,
                className,
                heading,
              }) => (
                <div className="grid-item" key={id}>
                  <div
                    className={`progress-item-two wow fadeInUp ${
                      className ? className : ""
                    }`}
                  >
                    <div className="icon">
                      {icon ? (
                        <i className={`flaticon ${icon}`}></i>
                      ) : (
                        <img src={imgSrc} className="icon_style" alt="Icon" />
                      )}
                    </div>
                    <h3>{title}</h3>
                    <h5 className="text-green">{heading}</h5>
                    <p>{description}</p>
                    {/* <a href="#" className="learn-more">
                    Read More <i className="fas fa-arrow-right"></i>
                  </a> */}
                    <span className="progress-step">{id}</span>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
